import { render, staticRenderFns } from "./notifications-senders.vue?vue&type=template&id=2460a4e5&"
import script from "./notifications-senders.vue?vue&type=script&lang=js&"
export * from "./notifications-senders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports